import * as React from "react"
import { SaTitle } from "../saTitle/saTitle"
// @ts-ignore
import {  saHomeExperts, saExpertsTitleContainer,saGrid,saExpertsGrid, saExpertsText, saExpertsSliderItem,saLink,saExpertsSliderItemInner,saExpertsSlider,saExpertsSliderItemImage, saExpertsSliderItemLogo,saExpertsSliderItemName,saExpertsSliderItemPosition,saExpertsSliderItemTag,saExpertsSliderItemLocation, btnPrev, btnNext, saExpertsTitle  } from "./saExperts.module.scss"

import { saInterfaceExpertsContainer } from "../saTypes"
import SaImage from "../saImage/saImage"

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "gatsby"
import blogDetailLink from '../../../utils/blogDetailLink'
import SaIcons from "../saIcons/saIcons"
import useWindowSize from "../saUseWindowDimensions/saUseWindowDimensions"
import { SaExpertsList } from "./saExpertsList"




export const SaExpertsSlider : React.FC<saInterfaceExpertsContainer> = ({...props}) => {


  if (!props) return null

/*
    private slider: typeof Slider | null; // <---- improved this type
    private setRef: (element: typeof Slider | null) => void; // <---- added this

    constructor(props) {
      super(props);

      this.slider = null;
      this.setRef = element => {
        this.slider = element;
      };

      this.play = this.play.bind(this);
      this.pause = this.pause.bind(this);
      this.next = this.next.bind(this);
      this.previous = this.previous.bind(this);
    }

    play() {
      this.slider.slickPlay();
    }

    pause() {
      this.slider.slickPause();
    }

    next() {
      this.slider.slickPause();
      this.slider.slickNext();
      setTimeout(() => this.slider.slickPlay(), 10000);
    }
    previous() {
      this.slider.slickPause();
      this.slider.slickPrev();
      setTimeout(() => this.slider.slickPlay(), 10000);
    }
*/


  const Arrow = (props) => {
    let className = props.type === "next" ? btnNext : btnPrev;
    className += " arrow";
    const char = props.type === "next" ? <SaIcons name={'rightArrow'} /> : <SaIcons name={'leftArrow'} />;


    return (
      <span className={className} onClick={props.onClick}>
        {char}
      </span>
    );
  }


  const play = (props) => {
    props.slider.slickPlay();
  }

  const pause = (props) => {
    props.slider.slickPause();
  }


/*
  next() {
    this.slider.slickPause();
    this.slider.slickNext();
    setTimeout(() => this.slider.slickPlay(), 10000);
  }
  const Previous = (props) => {
    props.slider.slickPause();
    props.slider.slickPrev();
    setTimeout(() => props.slider.slickPlay(), 10000);
  }*/


      const data = props;

      const posts = data.relationship
      //const postsCount : number = Object.keys(posts).length

      /*const saSettings : any = {
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        //centerMode: true,
        infinite: true,
        slidesToShow: (postsCount > 0 ? 4 : postsCount),
        speed: 750,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: (postsCount > 0 ? 3 : postsCount),
              infinite: true,
              dots: false,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: false,
              slidesToScroll: 1
            }
          }
        ]
      };*/



      let  listSlides = Object.values(posts).map((item ,index) => (
            <div key={index} className={saExpertsSliderItem}>
              <div className={saLink}>

                <div className={saExpertsSliderItemInner}>



                  {
                    item.saExpertDetails.expertDetails.photo &&
                    <div className={saExpertsSliderItemImage}>
                      <SaImage {...item.saExpertDetails.expertDetails.photo}/>
                    </div>
                  }

                  {
                    item.saExpertDetails.expertDetails.position &&
                    <div className={saExpertsSliderItemPosition}
                         dangerouslySetInnerHTML={{__html: item.saExpertDetails.expertDetails.position}}/>
                  }

                  <div className={saExpertsSliderItemName}
                       dangerouslySetInnerHTML={{__html: item.title}}/>

                  {
                    item.saExpertDetails.expertDetails.logo &&
                    <div className={saExpertsSliderItemLogo}>
                      <SaImage {...item.saExpertDetails.expertDetails.logo}/>
                    </div>
                  }

                </div>

              </div>
            </div>
          )
        )







      return (
        <div className={'saContainer ' + saHomeExperts}>

          {
            props.sectionTitle &&
            <div className={saExpertsTitleContainer}>
              <SaTitle title={props.sectionTitle}
                       classes={saExpertsTitle}/>
            </div>
          }

          {
            props.text &&
            <div className={saExpertsText}
                 dangerouslySetInnerHTML={{__html: props.text}} />
          }

          <div className={saExpertsSlider}>


            {/*<Slider ref={c => (this.slider = c)} {...saSettings}>
              <SaExpertsList {...this.props.relationship} />
            </Slider>*/}

            <Slider
              nextArrow={<Arrow type="next" />}
              prevArrow={<Arrow type="prev" />}
              dots={false}
              slidesToShow={1}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={3000}
              speed={750}
              cssEase={'linear'}
            >
              {listSlides}
            </Slider>

            {/*<div className={btnNext}  onClick={this.next}>
              <SaIcons name={'rightArrow'} />
            </div>*/}

          </div>




        </div>
      )


}
